/**
 * 契約情報ページ用のスクリプト
 */
 if (is_route('contract.index')) {
    // コンテンツ読み込み後
    $(document).on('amc:onload', function() {
        contract_event_set();
        contract_setting_event_set();
        contract_detail_event_set();
    });
}
/**
 * ページ読み込み時のイベント設定
 */
 window.contract_event_set = function() {

    /*---- 設定表示時 ----*/

    // 設定表示時
    $(document).on('click', '[data-setting-modal]', function () {
        _modal.create(this, 'setting-modal', ['id'], true);
    });
    
    /*---- 設定の保存時 ----*/

    // 設定保存時
    $(document).on('click', '[data-save-modal]', function () {
        $('[name^="extension_contract_count"]').each(function() {
            if ($(this).val() == '') {
                $(this).val('0');
            }
        });
        _modal.submit(this, 'save-modal');
    });

    /*---- 削除確認時 ----*/

    // 削除確認時
    $(document).on('click', '[data-confirm-modal]', function () {
        _modal.create(this, 'confirm-modal', ['id']);
    });

    /*---- 削除時 ----*/

    // 削除実行時
    $(document).on('click', '[data-delete-modal]', function () {
        _modal.submit(this, 'delete-modal');
    });

}
/**
 * 設定モーダル表示時のイベント設定
 */
 window.contract_setting_event_set = function() {

    /*---- グループ会社変更時 ----*/

    $(document).on('change', '#contract-setting-modal-holding_id', function() {
        var id = $(this).attr('id');
        var selected = $("#"+id+" option:selected");
        $('#contract-setting-modal-holding_code').val(selected.data('code'));
    });

    /*---- パスワード変更のフラグ変更時 ----*/

    $(document).off('change', '#contract-setting-modal-pass_flag');
    $(document).on('change', '#contract-setting-modal-pass_flag', function() {
        $('#password_form').toggleClass('display-none', !($(this).prop('checked')));
    });

    /*---- 解除ボタンクリック時 ----*/

    $(document).on('click', '.deactivate-button', function () {
        // アクションの取得
        let action = extend_url_query($(this).data('action'));
        var id = $(this).data('id');
        var target = $(this).data('target');
        if (ids.length > 0) {
            _ajax.post(action, {'id': id, 'target': target}, function (response) {
                // 完了メッセージをセットする
                _complete.set(response);
            }, function(xhr, status, errorThrown){
                _error.omitted(xhr, status, errorThrown);
            });    
        }
    });

    // オプション機能のyuriCargo連携のチェック変更時
    $(document).on('change', '#contract-setting-modal-extension_ids_1', function () {
        if ($(this).prop('checked')) {
            // チェックが有れば契約数を1にする
            $('#contract-setting-modal-extension_contract_count_1').val(1);
            $('[name="extension_contract_count[1]"]').val(1);
        } else {
            // チェックが無ければ契約数を0にする
            $('#contract-setting-modal-extension_contract_count_1').val(0);
            $('[name="extension_contract_count[1]"]').val(0);
        }
    });

}
/**
 * 詳細モーダル表示時のイベント設定
 */
window.contract_detail_event_set = function () {

    /*---- 詳細検索時 ----*/

    // 詳細検索時
    $(document).on('change', '#contract-detail-modal-terminal_name, #contract-detail-modal-device_token', function() {
        let form = $(this).parents('form');
        let datas = $(form).serializeArray();
        let action = $(form).attr('action');
        let modalId = $(form).data('modal_id');
        _modal.update(modalId, action, datas);
    });
}